import { Box, Button, Card, FormControl, Grid, InputAdornment, InputLabel, List, OutlinedInput, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import PersonIcon from '@mui/icons-material/Person';
import UserThreeDots from "../../components/Shared/UserThreeDots";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { useEffect, useState } from "react";
import { CorrectionalFacilityServiceInternal } from "../../services/correctionFacilities.service";
import FullPageLoader from "../../components/Shared/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CorrectionalFacilityManagement = () => {
    const [data, setData] = useState<any>([]);
    const [filteredData, setFilteredData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");


    const fetchDataFromApi = async () => {
        try {
            setIsLoading(true);
            const response = await CorrectionalFacilityServiceInternal.getCorrectionalFacilities();
            if (response?.data.isSuccess) {
                setData(response.data.data);
                setFilteredData(response.data.data);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data from API:', error);
        }
    }

    const navigate = useNavigate();
    const handleClick = (e: any) => {
        navigate("/new-correctional-facility");
    };

    const handleEditClick = (userId: number) => {
        setSelectedUserId(userId);
        navigate(`/edit-correctional-facility?id=${userId}`);
    };

    const handleDeleteFacility = async (userId: number) => {

        const response = await CorrectionalFacilityServiceInternal.deleteCorrectionalFacility(userId);
        if (response?.data.isSuccess) {
            fetchDataFromApi();
            toast.success("Deleted Successfully")
        }
    };

    const handleSearchInput = (e: any) => {
        setSearchText(e.target.value); 
    };

    useEffect(() => {
            fetchDataFromApi();
        }, []);
        
    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearchTerm(searchText);
        }, 500);

        return () => {
            clearTimeout(timerId);
        };
    }, [searchText]);

    useEffect(() => {
        const filtered = data.filter((user: { name: string; email: string; }) => 
            user.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
        );
        setFilteredData(filtered);
    }, [debouncedSearchTerm]);

    useEffect(() => {
        fetchDataFromApi();
    }, []);

    return (
        <Layout>
            {isLoading && <FullPageLoader />}
            <Typography
                sx={{
                    maxWidth: "100%",
                    minHeight: "70%",
                    maxHeight: "100%",
                    padding: 3,
                    margin: 2,
                    textAlign: "center",
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }}>
                    <FormControl sx={{ m: 1, width: '50%' }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type="text"
                            onChange={(e: any) => {
                                handleSearchInput(e);
                            }}
                            placeholder="Search here"
                            endAdornment={
                                <InputAdornment position="end" sx={{ cursor: "pointer " }}>
                                    <SearchSharpIcon/>
                                </InputAdornment>
                            }
                            label="Search"
                        />
                    </FormControl>
                    <Button onClick={handleClick} sx={{ height: "50px" }} variant="contained"> + New Correctional Facility</Button>
                </Box>
                <div>
                    <List sx={{ margin: "auto", textAlign: "center", width: "95%", marginTop: "5px" }}>
                        <Grid container sx={{ gridAutoRows: "1fr" }} rowSpacing={2} spacing={2} className="gridManagementScreen">
                            {
                                filteredData && filteredData.length > 0 ?
                                    (
                                        filteredData.map((list: any) => {

                                            return (
                                                <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                                                    <Card elevation={3} sx={{ p: 2, height: "95%" }} className='PendingRequestItem'>
                                                        <div>
                                                            <Box sx={{ display: "flex", mb: 3, justifyContent: "space-between" }}>
                                                                <div>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "start" }}>
                                                                        <div>
                                                                            {
                                                                                <PersonIcon sx={{ height: "80px", width: "80px", border: "2px solid", borderRadius: "50px" }} />
                                                                            }
                                                                        </div>
                                                                        <div className='userInformation'>
                                                                            <div className='userName'>{list.name}</div>
                                                                            <div className='userEmail'><b>{list.email}</b></div>
                                                                        </div>
                                                                    </Box>
                                                                </div>
                                                                <div>
                                                                    <UserThreeDots onEditClick={() => handleEditClick(list.id)} onDeleteClick={handleDeleteFacility} userId={list.id} />
                                                                </div>
                                                            </Box>
                                                        </div>
                                                    </Card>
                                                </Grid>
                                            )

                                        })
                                    ) :
                                    (
                                        <Grid container sx={{ justifyContent: "center", mt: "40px" }}>
                                            {!isLoading && <label>User List not Found</label>}
                                        </Grid>
                                    )
                            }
                        </Grid>
                    </List>
                </div>
            </Typography>
        </Layout>
    )
}
export default CorrectionalFacilityManagement;